// parse a YMD string into a date the local timezone
// have to add the timezone offset, otherwise date picker will show the wrong date
import moment from "moment";
import { parse, isValid, format } from "date-fns";

export const parseYMD = ymdStr => {
  const d = new Date(ymdStr);

  return new Date(
    d.getFullYear(),
    d.getMonth(),
    d.getDate(),
    d.getHours() + d.getTimezoneOffset() / 60,
  )
};

export const parseMDYformat = ymdStr => {
  const [year, month, day] = ymdStr.split('-').map(Number);
  const date = new Date(year, month - 1, day); // Month is zero-indexed

  const formattedDate = [
    String(date.getMonth() + 1).padStart(2, '0'),
    String(date.getDate()).padStart(2, '0'),
    date.getFullYear(),
  ].join('-');


  return formattedDate;

};

export const parseStringMDYformat = (ymdStr) => {
  const [year, month, day] = ymdStr.split('-');

  // Ensure month and day are always two digits
  const formattedDate = `${month.padStart(2, '0')}-${day.padStart(2, '0')}-${year}`;

  return formattedDate;
};

export const parseMDYformatWithoutUTC = ymdStr => {
  const [year, month, day] = ymdStr.split('-').map(Number);
  const date = new Date(year, month - 1, day);

  const formattedDate = [
    String(date.getMonth() + 1).padStart(2, '0'),
    String(date.getDate()).padStart(2, '0'),
    date.getFullYear(),
  ].join('-');

  return formattedDate;
};

export function getDateOnly(input) {
  let date = null;

  if (typeof input === 'string') {
    const parsed = parse(input, 'MM-dd-yyyy', new Date());

    date = isValid(parsed) ? parsed : null;
  } else if (input instanceof Date || typeof input === 'number') {
    const parsed = new Date(input);

    date = isValid(parsed) ? parsed : null;
  } else {
    date = new Date();
  }

  return isValid(date) ? format(date, 'yyyy-MM-dd') : null;
}

export function getCurrentDateTime() {
  const now = new Date();

  return format(now, 'yyyy:MM:dd HH:mm:ss');
}

export function formatMMDDDateWithoutTimezone(dateString) {
  if (!dateString) return "";
  const [year, month, day] = dateString.split("-").map(Number);
  return format(new Date(year, month - 1, day), "MM/dd");
}



moment.fn.roundNext15Min = function () {
  let intervals = Math.floor(this.minutes() / 15);

  if (this.minutes() % 15 !== 0) {
    intervals++;
    if (intervals === 4) {
      this.add(1, "hours");
      intervals = 0;
    }
    this.minutes(intervals * 15);

    return this;
  }
};